export const API_URL: string = process.env.REACT_APP_API_URL as string;
export const PARAMETROS_URL: string = process.env.REACT_APP_URL_PARAMETROS as string;
